import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

export interface UserAuthPostBackResp extends GeneralResp {
    reject: boolean;
    completed: boolean;
}

/**
 * @todo 基本身份驗證 ViewData
 */
const UserAuthPostBack = (postbackData: any): Promise<UserAuthPostBackResp> => {
    const url = RouteUrlList.API_UserAuthPostBack.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, postbackData, config).then((res: AxiosResponse<UserAuthPostBackResp>) => {
        return res.data;
    });
};

export default UserAuthPostBack;
